<template>
  <v-col cols="12" :md="md">
    <v-container>
      <v-row>
        <h6>{{item.elevator.name}}</h6>
      </v-row>
      <v-row>
        <p>{{item.elevator.zip}}, {{item.elevator.city}}</p>
      </v-row>
      <v-row>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="onlineColor"
              small>settings_input_antenna</v-icon>
          </template>
          <span>{{$t('display/elevator:statistic.online')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="deactivatedColor"
              small>block</v-icon>
          </template>
          <span>{{$t('display/elevator:statistic.deactivated')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="offlineColor"
              v-bind="attrs"
              v-on="on"
            >
              portable_wifi_off
            </v-icon>
          </template>
          <span>{{$t('display/elevator:statistic.offline')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="privateColor"
              dark
              v-bind="attrs"
              v-on="on"
            >
              lock
            </v-icon>
          </template>
          <span>{{$t('display/elevator:statistic.private')}}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <p>{{$t('display/elevator:statistic.usage')}}: {{usage}}</p>
      </v-row>
    </v-container>
  </v-col>
</template>
<script>
export default {
  name: "NameField",
  props: {
    item: Object,
    md: String
  },
  computed: {
    usage() {
      let usage = '';

      if (this.item.elevatorStatistic.advertisementsAverageMonth >= 20000) {
        usage = this.$t('display/elevator:statistic.strong');
      } else if(this.item.elevatorStatistic.advertisementsAverageMonth >= 7500){
        usage += this.$t('display/elevator:statistic.medium');
      }
      else {
        usage += this.$t('display/elevator:statistic.weak');
      }
      return usage;
    },

    onlineColor() {
      return this.item.elevator.active && this.item.elevator.online ? 'green' : 'grey';
    },

    deactivatedColor() {
      return !this.item.elevator.active ? 'orange' : 'grey';
    },

    offlineColor() {
      return this.item.elevator.active && !this.item.elevator.online ? 'red' : 'grey';
    },

    privateColor() {
      return this.item.elevator.isPrivate ? 'blue' : 'grey';
    }
  }
}
</script>